import { render, staticRenderFns } from "./settingTab.vue?vue&type=template&id=ec7ad22e&lang=pug"
import script from "./settingTab.vue?vue&type=script&lang=js"
export * from "./settingTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports